module.exports = {
    bodyFontFamily: "'Supply', 'Courier New', 'Courier', monospace",
    headingsFontFamily: "'Aktiv Grotesk', 'Helvetica', sans-serif",

    white: '#fff',
    black: '#000',
    red: 'red',

    // Colors
    lightGrey: '#e1e1e1',
    darkGrey: '#333',
    linkColor: '#1eaedb',
    fontColor: '#222',
    borderColor: '#bbb',

    // Breakpoints
    bpLargerThanMobile: '400px',
    bpLargerThanPhablet: '550px',
    bpLargerThanTablet: '750px',
    bpLargerThanDesktop: '1000px',
    bpLargerThanDesktophd: '1200px',
}
